import slick from "slick-carousel/slick/slick.min.js";
import slickCss from "slick-carousel/slick/slick.css";
import slickTheme from "slick-carousel/slick/slick-theme.css";


export default class SlickSlider {

  /**
   * 初期化
   * @param options
   */
  constructor(options) {
    this.options = $.extend(options);
    this.init();
  }

  /**
   * 各スライダー登録
   */
  init() {
    this.slickGallery();
    this.newsGallery();
  }


  slickGallery() {
    $('.js-slick-slider-gallery').each(function (i, elm) {
      let $slider_area = $(elm).parent();
      let $main_slide = $slider_area.find(".js-main");
      let $thumb_slide = $slider_area.find(".js-thumbnail");
      let $infiniteItem;

      if ($thumb_slide.find(".js-thumbnail-item") < 5) {
        $infiniteItem = false;
      }else {
        $infiniteItem = true;
      }

      console.log($thumb_slide.find(".js-thumbnail-item"));

      // データ属性の数字を割り振る
      $thumb_slide.find('.js-thumbnail-item').each(function () {
        let index = $thumb_slide.find('.js-thumbnail-item').index(this);
        $(this).attr("data-index", index);
      });

      // 初期化
      $main_slide.on('init', function (slick) {
        $thumb_slide.find(".js-thumbnail-item:first-child").addClass('thumb-current');
      });

      // サムネイルをクリックした時スライダー切り替え
      $thumb_slide.find(".js-thumbnail-item").on('click', function () {
        let index = $(this).attr("data-index");
        $main_slide.slick("slickGoTo", index, false);
      });

      // サムネイル画像のカレントを切り替え
      $main_slide.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        $thumb_slide.find(".js-thumbnail-item").removeClass("thumb-current");
        $thumb_slide.find('.js-thumbnail-item[data-index="' + nextSlide + '"]').addClass("thumb-current");
      });



      // オプション
      $main_slide.slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        accessibility: false,
        prevArrow: '<div class="slick-prev"><img src="../../../../assets/images/icon-thumbnail-prev.png"></div>',
        nextArrow: '<div class="slick-next"><img src="../../../../assets/images/icon-thumbnail-next.png"></div>',
        asNavFor: '.js-thumbnail',
        dots: false,
        arrows: true,
        fade: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {}
          },
        ]
      });
      $thumb_slide.slick({
        accessibility: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 800,
        arrows: false,
        dots: true,
        infinite: $infiniteItem,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        asNavFor: '.js-main',
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
            }
          },
        ]
      });

    });

  }




  newsGallery() {
    if ($('.c-gallery-slider').length < 0) {
      return false;
    }

    $('.c-gallery-slider__main').slick({
      infinite: true,
      arrow: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: '.c-gallery-slider__thumbnail',
      autoplaySpeed: 4000,
      speed: 700,
      centerMode: true,
      variableWidth: true,
      dots: false,
      prevArrow: '<div class="slick-prev"><img src="../../../../assets/images/icon-thumbnail-prev.png"></div>',
      nextArrow: '<div class="slick-next"><img src="../../../../assets/images/icon-thumbnail-next.png"></div>',
      responsive: [{
        breakpoint: 750,
        settings: {
          variableWidth: false,
        }
      }]
    });

    // 下段
    $('.c-gallery-slider__thumbnail').slick({
      accessibility: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 800,
      arrows: false,
      dots: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      variableWidth: true,
      asNavFor: '.c-gallery-slider__main',
      focusOnSelect: true,
      centerMode: false,
      responsive: [
        {
          breakpoint: 1920,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 7
          }
        },
        {
          breakpoint: 1240,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 5
          }
        },
        {
          breakpoint: 750,
          settings: {
            variableWidth: false,
            autoplaySpeed: 2500,
            slidesToShow: 4
          }
        }]
    });
  }

  // 複製して作業
  myCode() {
    console.log("Hello World");
  }
}




